import { inject, Injectable } from '@angular/core';

import {
  DashboardResponse,
  ExtendedCookieHelperUtilsService,
  HeaderFooterMachCoreContentService,
  LoggingService,
  UserSessionService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { ICorporatePartner } from '../../models/corporate-partner/corporate-partner.interface';
import { BUSINESS_ACCOUNT_OPTIONS_LIST } from '../../models/profile-selector.interface';
import { ProfileSelectorService } from '../data-services/profile-selector.service';

@Injectable({
  providedIn: 'root'
})
export class SwitchingAccountBaseService {
  userSession = inject(UserSessionService);
  cookieHelper = inject(ExtendedCookieHelperUtilsService);
  profileSelector = inject(ProfileSelectorService);
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  logging = inject(LoggingService);
  display = false;
  businessUser = false;
  intranetLink = false;
  businessAccount = false;
  oaSmeAccount = false;
  accountName = '';
  displayCorporateName = '';
  partnerId = '';
  crprtAgrmntTypeCode = '';
  program = '';
  crprtAgrmntId = '';
  contractMgtEnt = '';
  corpPartner = {} as ICorporatePartner;
  businessAccountOptionsLists = {} as BUSINESS_ACCOUNT_OPTIONS_LIST;
  dashboardResponse = {} as DashboardResponse;

  getAdditionalBusinessUserInfo(): {
    crprtAgrmntTypeCode: string;
    crprtAgrmntId: string;
    contractMgtEnt: string;
    program: string;
  } {
    const additionalInfo = {
      crprtAgrmntTypeCode: this.crprtAgrmntTypeCode,
      crprtAgrmntId: this.crprtAgrmntId,
      contractMgtEnt: this.contractMgtEnt,
      program: this.program
    };
    return additionalInfo;
  }

  setAdditionalBusinessUserInfo(
    corpAgreementCode: string,
    contractMgntEntity: string,
    programName: string,
    id: string
  ): void {
    this.crprtAgrmntTypeCode = corpAgreementCode;
    this.contractMgtEnt = contractMgntEntity;
    this.program = programName;
    this.crprtAgrmntId = id;
  }

  handleCookie(): void {
    const cookieObj = this.cookieHelper.getAccountCookie('account');
    if (cookieObj && cookieObj.length) {
      try {
        const parseObject = JSON.parse(cookieObj);
        this.accountName = decodeURIComponent(parseObject['name']);
        this.businessUser = parseObject['isBusiness'];
      } catch (error) {
        this.logging.log('Error parsing cookie object account');
      }
    }
  }
}
